import utilityStyles from '@lichtblick/photon/theme/utilities.module.scss';
import type { Colors } from '@lichtblick/photon/types/colors';
import classNames from 'classnames';
import type { FC, PropsWithChildren } from 'react';
import styles from './form-head.module.scss';

type FormHeadProps = PropsWithChildren & { background?: Colors };

export const FormHead: FC<FormHeadProps> = ({ background, children }) => (
  <div
    className={classNames(
      styles['form-head'],
      background && styles['has-bg'],
      background && utilityStyles[`theme-bg-${background}`],
    )}
  >
    {children}
  </div>
);
